<template>
  <div>
    <template v-for="stat in sorted" :key="`${stat.filter}-${stat.duration}`">
      <template v-if="stat.filter">
        <strong>{{ stat.filter }}:</strong>
      </template>
      {{ stat.count }}x{{ stat.duration }}s
      <span class="hidden md:inline text-xs">
        ({{ hoursFor(stat) }} hours)
      </span>
      <br />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface ImageStat {
  filter: string | null
  duration: number
  count: number
}

const props = defineProps<{ stats: ImageStat[] }>()

const sorted = computed(() =>
  [...props.stats].sort((a, b) => (a.filter ?? '').localeCompare(b.filter ?? ''))
)

function hoursFor(stat: ImageStat): string {
  return ((stat.count * stat.duration) / 3600).toFixed(2)
}
</script>
